import type { PressableProps as BaseProps, DimensionValue } from "react-native"

import React from "react"
import { Pressable as Base, StyleSheet } from "react-native"

import { testIds } from "./test-id"
import { SIZES } from "./theme"

import type { PressableState } from "./Button"
import type { WithOptionalTestId } from "./test-id"
import type { SpaceToken } from "./theme"
import type { View } from "./View"

export interface PressableProps extends WithOptionalTestId<BaseProps> {
  px?: SpaceToken
  trackHover?: boolean
  trackPress?: boolean
}

const styles = StyleSheet.create({
  hovered: {
    // backgroundColor: COLORS.$gray[300],
    opacity: 0.8,
  },
  // hoveredDark: {
  //   backgroundColor: COLORS.$warmGray[700],
  // },
  pressed: {
    // backgroundColor: COLORS.$gray[200],
    opacity: 0.6,
  },
  // pressedDark: {
  //   backgroundColor: COLORS.$warmGray[600],
  // },
})

/**
 * Encapsulated pressable component
 *
 *
 * https://stackoverflow.com/questions/68413202/react-native-how-to-add-opacity-feedback-to-pressable-component
 */
export const Pressable = React.forwardRef<typeof View, PressableProps>(
  function Pressable(
    {
      disabled = false,
      id,
      px,
      style,
      trackHover = true,
      trackPress = true,
      ...rest
    },
    ref,
  ) {
    // const isDark = useIsDarkMode()
    return (
      <Base
        // @ts-expect-error - need to fix ref typings for wrapped components
        ref={ref}
        {...testIds(id)}
        role={"button"}
        accessibilityState={{
          disabled: disabled === true,
        }}
        style={(state) => {
          const { hovered, pressed } = state as PressableState
          let paddingHorizontal: DimensionValue = 0

          if (px) {
            paddingHorizontal = SIZES[px]
          }
          return [
            { paddingHorizontal },
            trackHover && hovered === true && styles.hovered,
            // (isDark ? styles.hoveredDark : styles.hovered),
            trackPress && pressed && styles.pressed,
            // (isDark ? styles.pressedDark : styles.pressed),
            typeof style === "function" ? style(state) : style,
          ]
        }}
        {...rest}
      />
    )
  },
)
